import { useState } from "react";
import { logger } from "../lib/logger";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export function CopyBtn({ text, label, className = "" }) {
  const [copied, setCopied] = useState(false);
  const onClick = () => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true);
        toast.success("Copied!");
        setTimeout(() => setCopied(false), 2000);
      },
      (err) => {
        logger.error("Clipboard error", err);
        toast.error("Couldn't copy to clipboard");
      },
    );
  };
  return (
    <button onClick={onClick} className={`flex items-center gap-1.5 text-sm transition-all ${copied ? "text-green-600" : "text-zinc-500 hover:text-zinc-900"} ${className}`} data-testid="copy-btn">
      {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      {label && <span>{copied ? "Copied" : label}</span>}
    </button>
  );
}
